import React, { useState } from 'react';
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import { mainBlueColor } from '../../GlobalState';
import { ItemTableHeader } from './ItemTableHeader';
import { ItemTableBody } from './ItemTableBody';

const StyledTable = withStyles(theme => ({
  root: {
    padding: '0px !important'
  }
}))(Table);

type Tprops = {
  isDetailShow: boolean;
  workingBudgetId: number;
  reflectData: boolean;
};

/**
 * 見積書ベースの実行予算表
 * @constructor
 */
export const EstimateBased: React.FC<Tprops> = (props: Tprops) => {
  const { isDetailShow, workingBudgetId, reflectData } = props;

  const [mainColor] = useRecoilState(mainBlueColor);
  const classes = useStyles({ mainColor: mainColor });

  return (
    <div className={classes.container}>
      <TableContainer component={Paper} style={{ height: '600px' }}>
        <StyledTable
          stickyHeader
          className={classes.table}
          aria-label='sticky table'
          style={{ tableLayout: 'fixed' }}
        >
          <ItemTableHeader isDetailShow={isDetailShow} mode={0} />
          <TableBody>
            <ItemTableBody
              isDetailShow={isDetailShow}
              workingBudgetId={workingBudgetId}
              reflectData={reflectData}
            />
          </TableBody>
        </StyledTable>
      </TableContainer>
    </div>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
      padding: 10
    },
    table: {
      padding: 8,
      backgroundColor: props => props.mainColor,
      color: '#FFFFFF',
      fontWeight: 'bold'
    }
  })
);
